import React from 'react'
import { QuizQuestionBase } from '../QuizQuestion'

export const QuizQuestionPage: React.FC = () => {
  return <QuizQuestionBase />
}
